import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { SegmentType } from 'src/app/core/enums/enums';
import { Price } from 'src/app/core/models/cancellation.model';
import { SettingsService } from 'src/app/settings/services/settings.service';

@Component({
  selector: 'app-itinerary-box-resume',
  templateUrl: './itinerary-box-resume.component.html'
})
export class ItineraryBoxResumeComponent implements OnInit {
  segmentType = SegmentType;
  @Input() segments: any[];
  @Input() title: string;
  @Input() totalValue: Price;
  @Input() totalTitle: string;

  isAirline$: Observable<boolean>;

  constructor(private settingsService: SettingsService) {
    this.isAirline$ = this.settingsService.getClientIsAirline();
  }

  ngOnInit() {
    if (this.segments && this.segments.length > 0 && this.segments[0]?.selectedOption) {
      let refactorSegment = this.segments;
      this.segments = [];
      refactorSegment.forEach((resp: any) => {
        resp?.selectedOption?.segments.forEach((element) => {
          this.segments.push(element);
        });
      });
    }
  }
}
